import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { FileService } from '../services/file-service';

@Component({
  selector: 'app-folder-creation-modal',
  templateUrl: './folder-creation-modal.component.html',
  styleUrls: ['./folder-creation-modal.component.css']
})
export class FolderCreationModalComponent implements OnInit {

  name: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Subject<Object>, 
    public dialogRef: MatDialogRef<FolderCreationModalComponent>,
    private fileService: FileService, private router: Router
  ) { }

  ngOnInit() {
  }

  confirm() {
    const path = this.router.url.substring('/files/view/'.length);
    this.fileService.createFolder(this.name, path)
      .forEach(
        (response) => {
          this.data.next('folder');
          this.cancel();
        }
      );
  }

  cancel() {
    this.name = '';
    this.dialogRef.close();
  }

}
